// Angular
import { Injectable } from '@angular/core';
// NGRX
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// State
import { AppState } from '../../reducers';
import {
  TimelinesActionToggleLoading,
  TimelinesPageToggleLoading,
} from '../_actions/timeline.actions';
import { Router } from '@angular/router';
import { TimelineService } from '../_services/timeline.service';

@Injectable()
export class TimelineEffects {
  showPageLoadingDistpatcher = new TimelinesPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new TimelinesPageToggleLoading({ isLoading: false });

  showActionLoadingDistpatcher = new TimelinesActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new TimelinesActionToggleLoading({ isLoading: false });

  constructor(
    private actions$: Actions,
    private timeline: TimelineService,
    private store: Store<AppState>,
    private router: Router,
  ) {}
}
